import Wrapper from "../assets/wrappers/Footer";
import { Link } from "react-scroll";
import { BsWhatsapp, BsInstagram, BsLinkedin } from "react-icons/bs";

const Footer = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="icon-container">
          <a href="https://wa.me/96179459354" target="_blank" rel="noopener noreferrer">
            <BsWhatsapp className="icon" />
          </a>
          <a href="https://www.instagram.com/paul_abi_aad?igsh=eHN2OHBsNzhhMm1q" target="_blank" rel="noopener noreferrer">
            {" "}
            <BsInstagram className="icon" />{" "}
          </a>
          <a href="https://www.linkedin.com/in/paul-abi-aad/" target="_blank" rel="noopener noreferrer">
            {" "}
            <BsLinkedin className="icon" />{" "}
          </a>
        </div>

        <ul className="navbar">
          <Link to="how" offset={-30}>
            {" "}
            <li>Journey</li>
          </Link>
          <Link to="services" offset={-60}>
            {" "}
            <li>Services</li>
          </Link>
          <Link to="mainareas" offset={-60}>
            {" "}
            <li>Expertise</li>
          </Link>
          <Link to="reviews" offset={-120}>
            {" "}
            <li>Testimonials</li>
          </Link>
          <Link to="packages" offset={-60}>
            {" "}
            <li>Packages</li>
          </Link>
        </ul>

        <div className="contact-info">
          <p>
            EMAIL &nbsp;
            <a href="mailto:drpaulabiaad@hotmail.com">
              drpaulabiaad@hotmail.com
            </a>
          </p>
          <p>
            PHONE &nbsp;
            <a href="tel:+96179459354">
              +961 79 459 354
            </a>
          </p>
        </div>

        <p>@2026 Dr. Paul Abi Aad | All Rights Reserved</p>
      </div>
    </Wrapper>
  );
};

export default Footer;
